import { FrameworkCategoryDialogProps } from "./FrameworkCategoryDialog.tsx";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement, useState } from "react";
import { useValidator } from "../../../common/hooks/validation";
import { Trans } from "react-i18next";
import { FrameworkCategoryViewModel } from "../FrameworkCategories.types.ts";
import { post, put } from "../../../common/api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useFrameworkCategoryDialog(props: FrameworkCategoryDialogProps) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();
    const [saveModel, setSaveModel] = useState<FrameworkCategoryViewModel>(getDefaultModel(props.model));

    const validation = useValidator<FrameworkCategoryViewModel>((validators) => ({
        name: validators.validateNotEmpty((item) => item.name, translateString("name")),
    }));

    const isEdit = props.model !== null && props.model !== undefined;

    const addCategoryuMutation = useDotLegalMutation(create);
    const editCategoryMutation = useDotLegalMutation(update);

    const addCategory = () => {
        addCategoryuMutation.mutateAsync(saveModel!, {
            onSuccess: (response: any) => {
                snackbar.show(createElement(Trans, { i18nKey: "itemCreatedSuccess", values: { name: saveModel?.name } }));
                props.onDialogClose();
            },
        });
    };

    const editCategory = () => {
        editCategoryMutation.mutateAsync(saveModel!, {
            onSuccess: (response: any) => {
                snackbar.show(createElement(Trans, { i18nKey: "itemEditedSuccess", values: { name: saveModel?.name } }));
                props.onDialogClose();
            },
        });
    };

    const save = async () => {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }
        if (!isEdit) {
            addCategory();
        } else {
            editCategory();
        }
    };

    const updater = {
        onNameChange: (name: string) => {
            let temp = { ...saveModel };
            temp.name = name;
            setSaveModel(temp);
        },
        onDescriptionChange: (description: string) => {
            let temp = { ...saveModel };
            temp.description = description;
            setSaveModel(temp);
        },
        onCustomIdChange: (customId: string) => {
            let temp = { ...saveModel };
            temp.customId = customId;
            setSaveModel(temp);
        },
    };

    function create(saveModel: FrameworkCategoryViewModel) {
        return post<{}>(`/frameworks/${props.frameworkId}/categories`, saveModel);
    }

    function update(saveModel: FrameworkCategoryViewModel) {
        return put<{}>(`/frameworks/categories/${props.model!.id}`, saveModel);
    }

    return {
        validation,
        updater,
        saveModel,
        isSaving: addCategoryuMutation.isLoading || editCategoryMutation.isLoading,
        isEdit,
        save,
    };

    function getDefaultModel(model: FrameworkCategoryViewModel | undefined): FrameworkCategoryViewModel {
        return {
            id: model?.id ?? "",
            name: model?.name ?? "",
            description: model?.description,
            customId: model?.customId,
        };
    }
}
